module.exports = __webpack_public_path__ + "img/1.12e94e57.png";